module.exports = require('./readable').Transform



// WEBPACK FOOTER //
// /usr/local/www/sites/www.lactame.com/node/grm-data/git/cheminfo-js/molecular-formula/node_modules/readable-stream/transform.js